import { Variables } from "./Variables";
import triggerIcon from "../../../../new-images/profile/trigger-icon-info.svg";
import telegramIcon from "../../../../new-images/profile/telegram.svg";

export const useSubscribeTelegramVariables = () => {

  return new Variables(
    {
      img: triggerIcon,
      prompt: (
        <span>Новости из мира донорства крови, проекта DonorSearch, истории доноров и другие публикации.</span>
      ),
      label: "Будем на связи, подписывайтесь на нас в Telegram",
      buttonInfo: (
        <span><img src={telegramIcon} alt="" />Присоединиться</span>
        ),
      buttonHide: "Скрыть",
    },
  )
};